import React from 'react';
var IndicateurEtapes = function (_a) {
    var titreEtapeEnCours = _a.titreEtapeEnCours, titreProchaineEtape = _a.titreProchaineEtape, etapeEnCours = _a.etapeEnCours, nombreEtapes = _a.nombreEtapes, Component = _a.hx;
    if (!Component) {
        Component = "h2";
    }
    return (React.createElement("div", { className: "fr-stepper" },
        React.createElement(Component, { className: "fr-stepper__title" },
            React.createElement("span", { className: "fr-stepper__state" },
                "\u00C9tape ",
                etapeEnCours,
                " sur ",
                nombreEtapes),
            titreEtapeEnCours),
        React.createElement("div", { className: "fr-stepper__steps", "data-fr-current-step": etapeEnCours, "data-fr-steps": nombreEtapes }),
        titreProchaineEtape && (React.createElement("p", { className: "fr-stepper__details" },
            React.createElement("span", { className: "fr-text--bold" }, "\u00C9tape suivante :"),
            " ",
            titreProchaineEtape))));
};
export default IndicateurEtapes;
